// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * @shapeshiftoss/zcash-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 10.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Contains info about the network fee
 * @export
 * @interface NetworkFee
 */
export interface NetworkFee {
    /**
     * 
     * @type {number}
     * @memberof NetworkFee
     */
    satsPerKiloByte: number;
    /**
     * 
     * @type {number}
     * @memberof NetworkFee
     */
    blocksUntilConfirmation: number;
}

/**
 * Check if a given object implements the NetworkFee interface.
 */
export function instanceOfNetworkFee(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "satsPerKiloByte" in value;
    isInstance = isInstance && "blocksUntilConfirmation" in value;

    return isInstance;
}

export function NetworkFeeFromJSON(json: any): NetworkFee {
    return NetworkFeeFromJSONTyped(json, false);
}

export function NetworkFeeFromJSONTyped(json: any, ignoreDiscriminator: boolean): NetworkFee {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'satsPerKiloByte': json['satsPerKiloByte'],
        'blocksUntilConfirmation': json['blocksUntilConfirmation'],
    };
}

export function NetworkFeeToJSON(value?: NetworkFee | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'satsPerKiloByte': value.satsPerKiloByte,
        'blocksUntilConfirmation': value.blocksUntilConfirmation,
    };
}

